module.exports = __webpack_public_path__ + "img/btn_02_check.bed4e236.png";